/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Remove_User_LastInputs */



/**
* | output |
* | --- |
* | "A partner must keep at least one admin. Invite a replacement first." |
*
* @param {Partner_Admin_Remove_User_LastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_remove_user_last = /** @type {((inputs?: Partner_Admin_Remove_User_LastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Remove_User_LastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Partner muss mindestens einen Admin behalten. Laden Sie zuerst einen Ersatz ein.")
	return /** @type {LocalizedString} */ ("A partner must keep at least one admin. Invite a replacement first.")
});